<template>
  <div>
    <div class="message-content pt64">
      <div class="row">
        <div class="col-md-12 mb30">
          <h1 class="block-title">
            {{ $t('label.loanHistory') }}
          </h1>
        </div>
      </div>
      <div class="table-responsive">
        <table class="table">
          <thead>
            <tr>
              <th scope="col">
                {{ $t('label.action') }}
              </th>
              <th scope="col">
                {{ $t('label.released') }}
              </th>
              <th scope="col">
                {{ $t('label.loan') }}
              </th>
              <th scope="col">
                {{ $t('label.maturity') }}
              </th>
              <th scope="col">
                {{ $t('label.principal') }}
              </th>
              <th scope="col">
                {{ $t('label.dueFees') }}
              </th>
              <th scope="col">
                {{ $t('label.penalty') }}
              </th>
              <th scope="col">
                {{ $t('label.due') }}
              </th>
              <th scope="col">
                {{ $t('label.paid') }}
              </th>
              <th scope="col">
                {{ $t('label.balance') }}
              </th>
              <th scope="col">
                {{ $t('label.status') }}
              </th>
            </tr>
          </thead>
          <tbody>
            <template v-if="inProgress">
              <tr>
                <td
                  colspan="12"
                  class="text-center"
                >
                  <div
                    class="spinner-border spinner-border-sm"
                    role="status"
                  >
                    <span class="sr-only">{{ $t('label.loading') }}</span>
                  </div>
                  {{ $t('label.loading') }}
                </td>
              </tr>
            </template>
            <template v-else>
              <template v-if="loan_disk.length > 0">
                <tr
                  v-for="(item, key) in loan_disk"
                  :key="key"
                >
                  <td>
                    <button
                      class="btn btn-outline-info btn-sm"
                      @click="loanDetail(item.loan_id)"
                    >
                      <i class="fa fa-search" />
                    </button>
                  </td>
                  <td>{{ item.loan_released_date }}</td>
                  <td>{{ item.loan_application_id }}</td>
                  <td>{{ item.due_date }}</td>
                  <td>{{ item.loan_principal_amount }}</td>
                  <td>{{ item.loan_fee_id_2820 }}</td>
                  <td>{{ item.loan_manual_penalty_amount }}</td>
                  <td>
                    {{ calculateDueForPayday(item.loan_principal_amount, item.loan_interest, item.loan_released_date, item.due_date) }}
                  </td>
                  <td>{{ item.total_paid }}</td>
                  <td>{{ item.balance_amount }}</td>
                  <td>
                    <template v-if="item.child_status_id !== 0">
                      <template
                        v-if="item.child_status_id === 5 || item.child_status_id === 6 || item.child_status_id === 7 ||
                          item.child_status_id === 10 || item.child_status_id === 18"
                      >
                        <span class="badge badge-pill badge-primary">{{ childStatusIds[item.child_status_id] }}</span>
                      </template>
                      <template v-else-if="item.child_status_id === 14">
                        <span class="badge badge-pill badge-danger">{{ childStatusIds[item.child_status_id] }}</span>
                      </template>
                      <template v-else>
                        <span class="badge badge-pill badge-warning">{{ childStatusIds[item.child_status_id] }}</span>
                      </template>
                    </template>
                    <template v-else>
                      <template v-if="item.loan_status_id === 2">
                        <span class="badge badge-pill badge-success">{{ loanStatusIds[item.loan_status_id] }}</span>
                      </template>
                      <template v-else-if="item.loan_status_id === 1">
                        <span class="badge badge-pill badge-primary">{{ loanStatusIds[item.loan_status_id] }}</span>
                      </template>
                      <template v-else-if="item.loan_status_id === 3">
                        <span class="badge badge-pill badge-info">{{ loanStatusIds[item.loan_status_id] }}</span>
                      </template>
                      <template v-else-if="item.loan_status_id === 4">
                        <span class="badge badge-pill badge-warning">{{ loanStatusIds[item.loan_status_id] }}</span>
                      </template>
                      <template v-else>
                        <span class="badge badge-pill badge-secondary"> Other</span>
                      </template>
                    </template>
                  </td>
                </tr>
              </template>
              <template v-else>
                <tr>
                  <td
                    colspan="11"
                    class="text-center"
                  >
                    <figure>
                      <img
                        :src="'/img/icons/transfer_money.svg'"
                        alt="image"
                        class="mt-2"
                        style="width: 25%"
                      >
                      <figcaption class="mt-3">
                        {{ $t('label.noData') }}
                      </figcaption>
                    </figure>
                  </td>
                </tr>
              </template>
            </template>
          </tbody>
        </table>
      </div>
    </div>
    <template v-if="loan_disk_page.total_pages > 0 && loan_disk_page.total_pages > 1">
      <paginate
        class="float-right"
        v-model="loan_disk_page.current_page"
        :page-count="loan_disk_page.total_pages"
        :page-range="1"
        :margin-pages="1"
        :click-handler="getDataFromLoanDisk"
        :prev-text="'Prev'"
        :prev-class="'page-item'"
        :prev-link-class="'page-link'"
        :next-text="'Next'"
        :next-class="'page-item'"
        :next-link-class="'page-link'"
        :container-class="'pagination'"
        :page-class="'page-item'"
        :page-link-class="'page-link'"
      />
    </template>
  </div>
</template>

<script>
import { dataOptions } from '../../form/dataOptions'

export default {
  name: 'LoanTransaction',
  data () {
    return {
      loan_disk: [],
      loan_disk_page: {
        total_pages: 0,
        current_page: 1,
        per_page: 10,
        total_records: 0
      },
      repayment: [],
      loanStatusIds: dataOptions.loan_status_id,
      childStatusIds: dataOptions.child_status_id,
      inProgress: false
    }
  },
  computed: {
    is_loan_pending () {
      return this.$store.state.has_pending_loan
    }
  },
  methods: {
    getDataFromLoanDisk (page = 1) {
      this.loan_disk_page.current_page = page
      this.inProgress = true
      const borrower_uuid = JSON.parse(localStorage.getItem('borrower')).uuid
      this.$axios.post(this.$base_api + '/api/v1/frontend/get-loans-from-loan-disk', {
        borrower_uuid: borrower_uuid,
        page: this.loan_disk_page.current_page
      }).then((response) => {
        if (response.data.code === 1) {
          const result = response.data.data
          this.loan_disk_page = response.data
          this.loan_disk = result
        }
      }).catch((error) => {
        this.responseError(error.response)
      }).finally(() => {
        this.inProgress = false
      })
    },
    loanDetail (loan_id) {
      this.$router.push({ name: 'loan-detail', params: { loan_id: loan_id } })
    },
    calculateDueForPayday (principal, interrest, released_date, maturity_date) {
      const rate = interrest / 100
      const duration = this.$moment(maturity_date, 'MM/DD/YYYY').diff(this.$moment(released_date, 'MM/DD/YYYY'), 'day')
      const result = principal * ((1 + rate * (duration / 30)))
      return parseFloat(result).toFixed(2)
    }
  },
  mounted () {
    this.getDataFromLoanDisk()
  }
}
</script>

<style scoped>
  table tbody tr:last-child {
    border-bottom: 1px solid #dee2e6;
  }

  .table thead th,
  .table tbody td {
    vertical-align: middle !important;
  }
</style>
